/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {activitySearchPageInternal} from '../api'

export const useMutationActivitySearchPageInternal = createReactQueryMutationHook('activitySearchPageInternal', activitySearchPageInternal)
